<!-- Button -->
<div [dir]="lang === 'en'?'ltr':'rtl'">
    <button  [ngClass]="lang==='ar'?'mr-2':'ml-2'" mat-icon-button [matMenuTriggerFor]="userActions">
        <span
            class="relative inline-flex w-9 h-9 rounded-full p-0.5 sai-logo-avatar"
            [class.sai-logo-avatar--placeholder]="!companyPhoto"
        >
            <img
                *ngIf="companyPhoto"
                class="w-full h-full rounded-full object-cover"
                [authSrc]="companyPhoto"
                alt=""
            />
            <mat-icon
                class="sai-logo-avatar__placeholder-icon"
                *ngIf="!companyPhoto"
                [svgIcon]="'heroicons_outline:user'"
            ></mat-icon>
        </span>
    </button>

    <mat-menu [xPosition]="'before'" #userActions="matMenu" class="sai-menu">
        <ng-container *transloco="let t">
            <button mat-menu-item>
                <span class="flex flex-col leading-none">
                    <span>{{t('Signed in as')}}</span>
                    <span class="mt-1.5 text-md font-medium">{{company && company.email ? company.email :
                        userEmail}}</span>
                </span>
            </button>
            <ng-container>
                <ng-container *ngIf="userRole === 'company'">
                    <mat-divider class="my-2"></mat-divider>
                    <button mat-menu-item (click)="goToProfilePage()">
                        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                        <span>{{t('Profile')}}</span>
                    </button>

                    <button mat-menu-item (click)="seeSettingsForMenu()">
                        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
                        <span>{{t('Settings')}}</span>
                    </button>

                    <button mat-menu-item (click)="gotToSupport()">
                        <mat-icon [svgIcon]="'heroicons_outline:envelope'"></mat-icon>
                        <span>{{t('Support')}}</span>
                    </button>

                    <button *ngIf="showQuickTour" mat-menu-item (click)="startQuickTour()">
                        <mat-icon [svgIcon]="'heroicons_outline:map'"></mat-icon>
                        <span>{{t('Start Tour')}}</span>
                    </button>

                    <button mat-menu-item (click)="goToTerms()">
                        <mat-icon [svgIcon]="'heroicons_outline:information-circle'"></mat-icon>
                        <span>{{t('Terms and Policies')}}</span>
                    </button>
                </ng-container>

                <ng-container *ngIf="userRole === 'manager'">
                    <mat-divider class="my-2"></mat-divider>
                    <button mat-menu-item (click)="goToMyProfilePage()">
                        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                        <span>{{t('Profile')}}</span>
                    </button>

                    <button mat-menu-item (click)="seeSettingsForMenu()">
                        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
                        <span>{{t('Settings')}}</span>
                    </button>

                    <button mat-menu-item (click)="gotToSupport()">
                        <mat-icon [svgIcon]="'heroicons_outline:envelope'"></mat-icon>
                        <span>{{t('Support')}}</span>
                    </button>

                    <button mat-menu-item (click)="goToTerms()">
                        <mat-icon [svgIcon]="'heroicons_outline:information-circle'"></mat-icon>
                        <span>{{t('Terms and Policies')}}</span>
                    </button>
                </ng-container>
                <ng-container *ngIf="userRole === 'staff'">
                    <mat-divider class="my-2"></mat-divider>
                    <button mat-menu-item (click)="goToMyProfilePage()">
                        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                        <span>{{t('Profile')}}</span>
                    </button>

                    <button mat-menu-item (click)="seeSettingsForMenu()">
                        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
                        <span>{{t('Settings')}}</span>
                    </button>

                    <button mat-menu-item (click)="gotToSupport()">
                        <mat-icon [svgIcon]="'heroicons_outline:envelope'"></mat-icon>
                        <span>{{t('Support')}}</span>
                    </button>

                    <button mat-menu-item (click)="goToTerms()">
                        <mat-icon [svgIcon]="'heroicons_outline:information-circle'"></mat-icon>
                        <span>{{t('Terms and Policies')}}</span>
                    </button>
                </ng-container>
            </ng-container>
            <mat-divider class="my-2"></mat-divider>
            <button mat-menu-item (click)="signOut()">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
                <span>{{t('Sign out')}}</span>
            </button>
        </ng-container>
    </mat-menu>


</div>